import styled from 'styled-components';

export const Container = styled.button`
  ${({ $styles }) => $styles};
`;
